import axios from "axios";

export default {
  namespaced: true,
  state: {
    visits: [],
    images: [],
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    visitsMessage: ''
  },
  mutations: {
    RECEIVED_VISITS(state, payload) {
      state.visits = payload;
      state.isReceiving = false;
    },
    RECEIVING_VISITS(state) {
      state.isReceiving = true;
    },
    RECEIVED_VISIT(state, payload) {
      state = Object.assign(state, {
        visits: [...state.visits, payload],
        isReceiving: false,
      })
    },
    RECEIVING_VISIT(state) {
      state.isReceiving = true;
    },
    UPDATED_VISIT(state, payload) {
      let index = state.visits.findIndex(visit => visit._id === payload._id);
      state = Object.assign(state, {
        visits: state.visits.map((visit, i) => {
          if (i === index) {
            return Object.assign({}, visit, payload);
          }
          return visit;
        }),
        isUpdating: false,
        visitsMessage: 'Visits has been updating!',
      })
    },
    UPDATING_VISIT(state) {
      state.isUpdating = true;
    },
    DELETED_VISIT(state, payload) {
      let indexToDelete = state.visits.findIndex(visit => visit._id === payload._id);
      let visits = [...state.visits];
      visits.splice(indexToDelete, 1);
      state = Object.assign(state, {
        visits: [...visits],
        isDeleting: false,
        idToDelete: null,
        visitsMessage: 'Visit has been Deleted!',
      });
    },
    DELETING_VISIT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async getVisitsRequest({dispatch}) {
      dispatch("receivingVisits");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/visits';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "GET", url: url, headers: headers})
      .then(res => {
        dispatch("receiveVisits", res.data);
      })
    },
    updateVisitRequest({dispatch}, payload) {
      dispatch("updatingVisit");
      let id = payload._id;
      delete payload['_id'];

      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/update/visit/' + id;
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};

      axios({method: "PUT",url: url,headers: headers,data: payload})
      .then(function (res) {
        dispatch("updateVisit", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    updateVisitImageRequest({dispatch}, payload) {
      dispatch("updatingVisit");
      let token = localStorage.getItem('token');
      let id = payload._id;
      delete payload['_id'];

      var url = 'https://api.tradexc.com:3000/update/visit/image/' + id;
      let data = new FormData();
      data.append('image', payload.visitimage, payload.imagename); 
      delete payload['visitimage'];
      for (let x in payload) {data.append(x, payload[x]);}
      let headers = {'Content-Type': 'multipart/form-data','Authorization': 'Bearer ' + token};
      axios({method: "PUT", url: url,headers: headers,data: data})
      .then(function (res) {
        dispatch("updateVisit", res.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });
    },
    createVisitRequest({dispatch}, payload) {
      dispatch("receivingVisits");
      let url;
      let data;
      let token = localStorage.getItem('token');
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      if(payload.visitimage !== undefined) {
        url = 'https://api.tradexc.com:3000/insert/visit/withimage';
        data = new FormData();
        data.append('image', payload.visitimage, payload.imagename); 
        delete payload['visitimage'];
        for (let x in payload) {data.append(x, payload[x]);}
      } else {
        url = 'https://api.tradexc.com:3000/insert/visit';
        data = payload;
      }
      axios({method: "POST", url: url, headers: headers, data: data})
      .then((response)=>{
        dispatch("receiveVisit", response.data);
      })
      .catch((error) => {
        console.error('Error:', error);
        this.alertmessage = error;
      });	
    },
    deleteVisitRequest({dispatch}, payload) {
      dispatch("deletingVisit", payload);
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/delete/visit/' + payload._id
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      axios({method: "DELETE", url: url, headers: headers}).then(() => {
        dispatch("deleteVisit", {_id: payload._id});
      })
    },
    receiveVisits({commit}, payload) {
      commit("RECEIVED_VISITS", payload)
    },
    receivingVisits({commit}) {
      commit("RECEIVING_VISITS")
    },
    receiveVisit({commit}, payload) {
      commit("RECEIVED_VISIT", payload)
    },
    receivingVisit({commit}) {
      commit("RECEIVING_VISIT")
    },
    updateVisit({commit}, payload) {
      commit("UPDATED_VISIT", payload)
    },
    updatingVisit({commit}) {
      commit("UPDATING_VISIT")
    },
    deleteVisit({commit}, payload) {
      commit("DELETED_VISIT", payload)
    },
    deletingVisit({commit}, payload) {
      commit("DELETING_VISIT", payload)
    }
  },
};
